import React from 'react';

export default function SectionCard({ icon, title, subtitle, right, children, className = '' }) {
  return (
    <section className={`section-card ${className}`}>
      <div className="section-heading">
        <div className="section-title-wrap">
          <span className="section-icon">{icon}</span>
          <div><h2>{title}</h2>{subtitle && <p>{subtitle}</p>}</div>
        </div>
        {right && <div>{right}</div>}
      </div>
      {children}
    </section>
  );
}
